export default "__VITE_ASSET__C_H9RBNe__"